import {put, takeLatest, select} from 'redux-saga/effects'

import * as api from '../api/api'
import * as events from '../store/events'
import {isGroomRentsFreeTargetCustomer} from '../store/cross'

import {throwBadResponseError, getJson} from './helpers'
import {
  getGrfQualificationStatusFailure,
  getGrfQualificationStatusSuccess,
} from '../actions/groomRentsFree'
import {
  ADD_PARTICIPANT,
  REMOVE_PARTICIPANT,
  UPDATE_IS_OWNER_WEARING_LOOK_SUCCESS,
} from '../actions/people'
import {GET_EVENT_LOOKS_SUCCESS} from '../actions/api'
import {
  CHANGE_CURRENT_EVENT_SUCCESS,
  UPDATE_CURRENT_EVENT,
  UPDATE_CURRENT_TYPE,
} from '../actions/events'
import {ADD_LOOK, ADD_LOOK_ITEM, DELETE_LOOK, DELETE_LOOK_ITEM} from '../actions/looks'

export function* getGrfQualificationStatusWorker() {
  const state = yield select()
  const orderId = events.currentOrderId(state)

  if (isGroomRentsFreeTargetCustomer(state)) {
    try {
      const payload = yield api.getGroomRentsFreeQualification(orderId).then(
        api.onStatus({
          OK: getJson,
          DEFAULT: throwBadResponseError,
        }),
      )
      yield put(getGrfQualificationStatusSuccess(payload))
    } catch (e) {
      yield put(getGrfQualificationStatusFailure())
    }
  }
}

export function* getGrfQualificationStatusSaga() {
  yield takeLatest(
    [
      ADD_LOOK,
      DELETE_LOOK,
      ADD_LOOK_ITEM,
      DELETE_LOOK_ITEM,
      ADD_PARTICIPANT,
      REMOVE_PARTICIPANT,
      UPDATE_IS_OWNER_WEARING_LOOK_SUCCESS,
      UPDATE_CURRENT_EVENT, // to capture dashboard event type changes
      UPDATE_CURRENT_TYPE,
      GET_EVENT_LOOKS_SUCCESS,
      CHANGE_CURRENT_EVENT_SUCCESS,
    ],
    getGrfQualificationStatusWorker,
  )
}
